module.exports = __webpack_public_path__ + "img/user.17c92224.png";